import React from "react";
import styled from "styled-components";
import Table from "../../Common/Table";
import TableFields from "../../../constants/SubIssueTypes/TableFields.json";
import { FlexContainer, Pill } from "../../../constants/assets/containers";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import variables from "../../../constants/assets/variables";
import SubIssueTypesActionBar from "./SubIssueTypeActionBar";
import ConfirmationModal from "../../Common/ConfirmationModal";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as SubIssueTypeActions from "../../../store/actions/SubIssueTypes";

const SubIssueTypeList = (props) => {
  const {
    subIssueTypeList,
    saveUpdateSubIssueTypes,
    currentPage,
    activeFilters,
    getSubIssueTypesList,
  } = props;
  const [showActionType, setShowActionType] = React.useState(false);
  const [activeSubIssueTypesId, setActiveSubIssueTypesId] = React.useState();
  const [activeSubIssueTypesEnabled, setActiveSubIssueTypesEnabled] =
    React.useState();
  const [showConfirmationModal, setShowConfirmationModal] =
    React.useState(false);
  const [actionCoord, setActionCoord] = React.useState({
    top: "",
    right: "",
  });

  const handleBlur = () => {
    setShowActionType(false);
  };

  const handleAction = (action_id, subIssueId, enabled) => {
    setShowActionType(true);
    const activeAct = document.getElementById(`${action_id}`);
    setActiveSubIssueTypesId(subIssueId);
    setActiveSubIssueTypesEnabled(enabled);
    if (activeAct) {
      setActionCoord({
        top: activeAct.getBoundingClientRect().top + 10,
        right: window.innerWidth - activeAct.getBoundingClientRect().right,
      });
      activeAct.style.zIndex = 200;
    }
  };
  const openEnableDisableModal = () => {
    setShowConfirmationModal(true);
  };
  const closeEnableDisableModal = () => {
    setShowConfirmationModal(false);
  };

  const handleEnableDisable = (type, subIssueId) => {
    const subIssueTypeData = subIssueTypeList.find(
      (item) => item.id === subIssueId
    );

    if (subIssueTypeData) {
      const completeObj = {
        ...subIssueTypeData,
        conditionsV2: transformConditionsToV2(
          subIssueTypeData.conditionsV2 || []
        ),
        enabled: !type,
        dontUpdateVernacularTranslations: true,
      };

      saveUpdateSubIssueTypes("edit", completeObj)
        .then((res) => {
          getSubIssueTypesList(currentPage, activeFilters);
          closeEnableDisableModal();
        })
        .catch((err) => {
          console.error("Error updating sub issue type:", err);
          closeEnableDisableModal();
        });
    }
  };

  const transformConditionsToV2 = (conditions) => {
    if (!Array.isArray(conditions) || conditions.length === 0) {
      return [];
    }

    const conditionsV2 = [];

    conditions.forEach((condition) => {
      if (
        !condition.hasOwnProperty("key") &&
        !condition.hasOwnProperty("value")
      ) {
        const key = Object.keys(condition)[0];
        if (key && key.trim() !== "") {
          conditionsV2.push(condition);
        }
        return;
      }

      const { key, value } = condition;

      if (!key || key.trim() === "") {
        return;
      }

      const conditionObj = {};
      conditionObj[key] = value;
      conditionsV2.push(conditionObj);
    });

    return conditionsV2;
  };

  const getFieldValue = (subIssueType, key, index) => {
    switch (key) {
      case "id":
        return subIssueType.cartheroRefId ? subIssueType.cartheroRefId : "-";
      case "enabled":
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={!subIssueType[key]}>
              {subIssueType[key] ? "Yes" : "No"}
            </Pill>
          </div>
        );
      case "action":
        return (
          <FlexContainer
            justify="flex-start"
            onClick={() => {
              handleAction(
                `actions_${index}`,
                subIssueType.id,
                subIssueType.enabled
              );
            }}
            className={"edit-options cursor-pointer actions-holder"}
            id={`actions_${index}`}
          >
            <span>Actions</span> <ChevronDown color={variables.primaryColor} />{" "}
          </FlexContainer>
        );

      case "conditions":
        return subIssueType.conditionsV2 && subIssueType.conditionsV2.length
          ? JSON.stringify(subIssueType.conditionsV2)
          : "-";
      default:
        return subIssueType[key] ? subIssueType[key] : "-";
    }
  };

  return (
    <SubIssueTypeListContainer>
      <Table
        list={subIssueTypeList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
      <ConfirmationModal
        open={showConfirmationModal}
        modalTitle={`${
          activeSubIssueTypesEnabled ? "Disable" : "Enable"
        } Issue Type`}
        onCofirmCancelHandler={closeEnableDisableModal}
        onCofirmSuccessHandler={() =>
          handleEnableDisable(activeSubIssueTypesEnabled, activeSubIssueTypesId)
        }
        successButtonText={activeSubIssueTypesEnabled ? "Disable" : "Enable"}
        CancelButtonText={"Cancel"}
      >
        <p>
          Are you sure you want to{" "}
          {activeSubIssueTypesEnabled ? "Disable" : "Enable"} the Sub Issue
          type?
        </p>
      </ConfirmationModal>
      {showActionType && (
        <SubIssueTypesActionBar
          handleBlur={handleBlur}
          top={actionCoord.top}
          right={actionCoord.right}
          subIssueTypesId={activeSubIssueTypesId}
          enabled={activeSubIssueTypesEnabled}
          openEnableDisableModal={openEnableDisableModal}
        />
      )}
    </SubIssueTypeListContainer>
  );
};
const SubIssueTypeListContainer = styled.div`
  height: calc(100vh - 215px);
`;

function mapStateToProps(state) {
  const { SubIssueTypes } = state;
  return {
    currentPage: SubIssueTypes.currentPage,
    activeFilters: SubIssueTypes.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveUpdateSubIssueTypes: bindActionCreators(
      SubIssueTypeActions.saveUpdateSubIssueTypes,
      dispatch
    ),
    getSubIssueTypesList: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypesList,
      dispatch
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SubIssueTypeList);
